import { render, staticRenderFns } from "./ListFolderItem.vue?vue&type=template&id=b5dbe636&scoped=true"
import script from "./ListFolderItem.vue?vue&type=script&lang=ts"
export * from "./ListFolderItem.vue?vue&type=script&lang=ts"
import style0 from "./ListFolderItem.vue?vue&type=style&index=0&id=b5dbe636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dbe636",
  null
  
)

export default component.exports